import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import "./SurveyView.css"

class SurveyView extends React.Component {
  onSelected = async selected => {
    await this.props.onSelectResponse(selected)
  }
  render = () => {
    const {
      question,
      description,
      responseOptions,
      onGetOptionIcon
    } = this.props
    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <p className="Survey_Title">{question}</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="survey_PollRow" columns="equal">
          {Object.keys(responseOptions).map(option => {
            const responseOption = responseOptions[option]
            return (
              responseOption && (
                <Grid.Column textAlign="center" key={responseOption.value}>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => this.onSelected(responseOption.value)}
                    data-tooltip={responseOption.label}
                    data-testid={responseOption.value}
                  >
                    {onGetOptionIcon
                      ? onGetOptionIcon(responseOption.value)
                      : null}
                    <div className="Survey_OptionText">
                      {responseOption.label}
                    </div>
                  </div>
                </Grid.Column>
              )
            )
          })}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <p className="greyed-text Survey_Description">{description}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default SurveyView
